const group = document.getElementById('more-subscriptions-group');

if (group) { 
    group.addEventListener('click', function (e) {
        const button = e.target.closest('.btn-abo-more');
        if (!button) return;

        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const isOpen = button.getAttribute('aria-expanded') === 'true';

        // sluit alle panels
        group.querySelectorAll('.btn-abo-more').forEach(btn => {
            const p = document.getElementById(btn.getAttribute('aria-controls'));
            btn.setAttribute('aria-expanded', 'false');
            p.hidden = true;
        });

        // open gekozen panel
        if (!isOpen) {
            button.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
        }
    });
}
